// Firing Fee Calculator JavaScript

// ==================== API CONFIGURATION ====================
// Switch between 'dev' and 'prod' environments easily
const API_CONFIG = {
  environment: "prod", // Change to 'prod' when ready
  endpoints: {
    dev: "https://108828c8-d3a6-4b1b-97e5-5085448b5c06-00-28ev2ruihx5v8.janeway.replit.dev",
    prod: "https://throwing-shapes-new-api.replit.app",
  },
  getBaseUrl() {
    return this.endpoints[this.environment];
  },
  getCreateAndCheckoutUrl() {
    return `${this.getBaseUrl()}/api/shopify/create-and-checkout`;
  },
};
// ==========================================================

document.addEventListener("DOMContentLoaded", function () {
  const scriptTag = document.querySelector(
    'script[src*="firing-fee-calculator.js"]'
  );

  if (!scriptTag) {
    console.error("Firing fee calculator script tag not found");
    return;
  }

  const config = {
    memberRate: parseFloat(scriptTag.dataset.memberRate) || 3,
    guestRate: parseFloat(scriptTag.dataset.guestRate) || 8,
    autoLogout: scriptTag.dataset.autoLogout === "true",
    logoutTimeout: (parseInt(scriptTag.dataset.logoutTimeout) || 3) * 60 * 1000,
    firingFeeVariantId: scriptTag.dataset.variantId,
    productId: scriptTag.dataset.productId,
  };

  let pieces = [];
  let editingIndex = -1;
  let timeoutId = null;
  let timeRemaining = config.logoutTimeout;

  // Log current API environment
  console.log(`🔧 API Environment: ${API_CONFIG.environment.toUpperCase()}`);
  console.log(`🌐 API Base URL: ${API_CONFIG.getBaseUrl()}`);

  const elements = {
    form: document.getElementById("piece-form"),
    customerName: document.getElementById("customer-name"),
    globalShelfNumber: document.getElementById("global-shelf-number"),
    pieceName: document.getElementById("piece-name"),
    pieceWeight: document.getElementById("piece-weight"),
    weightUnit: document.getElementById("weight-unit"),
    calculatedCost: document.getElementById("calculated-cost"),
    piecesList: document.getElementById("pieces-list"),
    piecesContainer: document.getElementById("pieces-container"),
    orderSummary: document.getElementById("order-summary"),
    totalPieces: document.getElementById("total-pieces"),
    totalWeight: document.getElementById("total-weight"),
    totalCost: document.getElementById("total-cost"),
    addToCartBtn: document.getElementById("add-to-cart-btn"),
    errorMessage: document.getElementById("error-message"),
    successMessage: document.getElementById("success-message"),
    addPieceText: document.getElementById("add-piece-text"),
    addLoading: document.getElementById("add-loading"),
    cartText: document.getElementById("cart-text"),
    cartLoading: document.getElementById("cart-loading"),
    countdownTimer: document.getElementById("countdown-timer"),
  };

  const PricingCalculator = {
    calculateCost(weight, unit, customerType) {
      const weightInKg = unit === "g" ? weight / 1000 : parseFloat(weight);
      const rate =
        customerType === "member" ? config.memberRate : config.guestRate;
      return (weightInKg * rate).toFixed(2);
    },
  };

  // Overlay Manager for handling loading states
  const OverlayManager = {
    createOverlay() {
      if (document.getElementById("checkout-overlay")) {
        return; // Overlay already exists
      }

      const overlay = document.createElement("div");
      overlay.id = "checkout-overlay";
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        font-family: inherit;
      `;

      const content = document.createElement("div");
      content.style.cssText = `
        background: white;
        padding: 2rem;
        border-radius: 8px;
        text-align: center;
        max-width: 400px;
        margin: 1rem;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      `;

      const spinner = document.createElement("div");
      spinner.style.cssText = `
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 1rem auto;
      `;

      const title = document.createElement("h3");
      title.textContent = "Creating Your Checkout...";
      title.style.cssText = `
        margin: 0 0 1rem 0;
        color: #333;
        font-size: 1.2rem;
      `;

      const message = document.createElement("p");
      message.id = "overlay-message";
      message.textContent =
        "Please wait while we prepare your firing fees for checkout. This may take a few moments.";
      message.style.cssText = `
        margin: 0;
        color: #666;
        line-height: 1.4;
      `;

      // Add CSS animation for spinner
      if (!document.getElementById("spinner-styles")) {
        const style = document.createElement("style");
        style.id = "spinner-styles";
        style.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);
      }

      content.appendChild(spinner);
      content.appendChild(title);
      content.appendChild(message);
      overlay.appendChild(content);
      document.body.appendChild(overlay);
    },

    updateOverlayMessage(message) {
      const messageEl = document.getElementById("overlay-message");
      if (messageEl) {
        messageEl.textContent = message;
      }
    },

    showError(message) {
      const overlay = document.getElementById("checkout-overlay");
      if (overlay) {
        const content = overlay.querySelector("div");
        content.innerHTML = `
          <div style="color: #e74c3c; font-size: 2rem; margin-bottom: 1rem;">⚠️</div>
          <h3 style="margin: 0 0 1rem 0; color: #e74c3c;">Error</h3>
          <p style="margin: 0 0 1.5rem 0; color: #666;">${message}</p>
          <button onclick="document.getElementById('checkout-overlay').remove()" 
                  style="background: #e74c3c; color: white; border: none; padding: 0.5rem 1rem; border-radius: 4px; cursor: pointer;">
            Close
          </button>
        `;
      }
    },

    removeOverlay() {
      const overlay = document.getElementById("checkout-overlay");
      if (overlay) {
        overlay.remove();
      }
    },
  };

  const PieceManager = {
    addPiece(pieceData) {
      if (editingIndex >= 0) {
        pieces[editingIndex] = pieceData;
        editingIndex = -1;
        elements.addPieceText.textContent = "Add Piece";
      } else {
        pieces.push(pieceData);
      }
      this.updateDisplay();
      this.clearForm();
    },

    removePiece(index) {
      pieces.splice(index, 1);
      this.updateDisplay();
    },

    editPiece(index) {
      const piece = pieces[index];
      editingIndex = index;

      elements.pieceName.value = piece.name;
      elements.pieceWeight.value = piece.weight;
      elements.weightUnit.value = piece.unit;

      const firingTypeRadio = document.querySelector(
        `input[name="firing-type"][value="${piece.firingType}"]`
      );
      const customerTypeRadio = document.querySelector(
        `input[name="customer-type"][value="${piece.customerType}"]`
      );

      if (firingTypeRadio) {
        firingTypeRadio.checked = true;
        firingTypeRadio.closest(".radio-option").classList.add("selected");
      }
      if (customerTypeRadio) {
        customerTypeRadio.checked = true;
        customerTypeRadio.closest(".radio-option").classList.add("selected");
      }

      elements.addPieceText.textContent = "Update Piece";
      this.calculateRealTime();

      elements.form.scrollIntoView({ behavior: "smooth" });
    },

    updateDisplay() {
      if (pieces.length === 0) {
        elements.piecesList.style.display = "none";
        elements.orderSummary.style.display = "none";
        return;
      }

      elements.piecesList.style.display = "block";
      elements.orderSummary.style.display = "block";

      elements.piecesContainer.innerHTML = pieces
        .map(
          (piece, index) => `
        <div class="piece-item">
          <div class="piece-details">
            <div class="piece-name">${this.escapeHtml(
              piece.name
            )} - Shelf ${this.escapeHtml(piece.shelfNumber)}</div>
            <div class="piece-info">
              ${piece.weight}${piece.unit}, ${piece.firingType}, ${
            piece.customerType
          } - €${piece.cost}
            </div>
          </div>
          <div class="piece-actions">
            <button type="button" class="btn-secondary" data-edit-index="${index}">Edit</button>
            <button type="button" class="btn-secondary" data-remove-index="${index}">Remove</button>
          </div>
        </div>
      `
        )
        .join("");

      const editButtons =
        elements.piecesContainer.querySelectorAll("[data-edit-index]");
      const removeButtons = elements.piecesContainer.querySelectorAll(
        "[data-remove-index]"
      );

      editButtons.forEach((btn) => {
        btn.addEventListener("click", () =>
          this.editPiece(parseInt(btn.dataset.editIndex))
        );
      });

      removeButtons.forEach((btn) => {
        btn.addEventListener("click", () =>
          this.removePiece(parseInt(btn.dataset.removeIndex))
        );
      });

      const totalPieces = pieces.length;
      const totalWeightG = pieces.reduce((sum, piece) => {
        const weightInG =
          piece.unit === "kg" ? piece.weight * 1000 : piece.weight;
        return sum + weightInG;
      }, 0);
      const totalCost = pieces.reduce(
        (sum, piece) => sum + parseFloat(piece.cost),
        0
      );

      elements.totalPieces.textContent = totalPieces;
      elements.totalWeight.textContent =
        totalWeightG >= 1000
          ? `${(totalWeightG / 1000).toFixed(1)}kg`
          : `${totalWeightG}g`;
      elements.totalCost.textContent = `€${totalCost.toFixed(2)}`;
    },

    clearForm() {
      elements.form.reset();
      elements.calculatedCost.textContent = "Cost: €0.00";
      editingIndex = -1;
      elements.addPieceText.textContent = "Add Piece";

      // Clear radio button selected states
      document.querySelectorAll(".radio-option").forEach((option) => {
        option.classList.remove("selected");
      });
    },

    calculateRealTime() {
      const weight = parseFloat(elements.pieceWeight.value) || 0;
      const unit = elements.weightUnit.value;
      const customerType = document.querySelector(
        'input[name="customer-type"]:checked'
      )?.value;

      if (weight > 0 && customerType) {
        const cost = PricingCalculator.calculateCost(
          weight,
          unit,
          customerType
        );
        elements.calculatedCost.textContent = `Cost: €${cost}`;
      } else {
        elements.calculatedCost.textContent = "Cost: €0.00";
      }
    },

    escapeHtml(unsafe) {
      return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
  };

  const CartManager = {
    async createAndCheckout() {
      if (pieces.length === 0) {
        this.showError("No pieces to add to cart");
        return;
      }

      // Show overlay
      OverlayManager.createOverlay();

      try {
        // Transform pieces data to API format
        const products = this.formatProductsForAPI();
        const quantities = new Array(pieces.length).fill(1);

        OverlayManager.updateOverlayMessage(
          `Creating ${pieces.length} firing fee${
            pieces.length > 1 ? "s" : ""
          } and preparing checkout...`
        );

        console.log(`📡 Calling API: ${API_CONFIG.getCreateAndCheckoutUrl()}`);
        console.log("📦 Payload:", { products, quantities });

        const response = await fetch(API_CONFIG.getCreateAndCheckoutUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            products: products,
            quantities: quantities,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("✅ API Response:", data);

        if (response.ok && data.success) {
          OverlayManager.updateOverlayMessage("Redirecting to checkout...");

          // Clear all data before redirecting
          this.clearAll();

          // Small delay to show the redirect message
          setTimeout(() => {
            window.location.href = data.checkout.url;
          }, 1000);
        } else {
          throw new Error(data.message || "Failed to create checkout");
        }
      } catch (error) {
        console.error("❌ Checkout error:", error);

        let errorMessage = "Error creating checkout. Please try again.";

        if (error.name === "TypeError" && error.message.includes("fetch")) {
          errorMessage =
            "Network error. Please check your connection and try again.";
        } else if (error.message.includes("HTTP")) {
          errorMessage = `Server error (${error.message}). Please try again or contact support.`;
        } else if (error.message) {
          errorMessage = error.message;
        }

        OverlayManager.showError(errorMessage);
      }
    },

    formatProductsForAPI() {
      const customerName = elements.customerName.value.trim();

      return pieces.map((piece) => ({
        title: `${customerName} - ${piece.name}`,
        price: piece.cost,
        weight: `${piece.weight}${piece.unit}`,
        firingType: piece.firingType,
        customerType: piece.customerType,
        shelfNumber: piece.shelfNumber,
      }));
    },

    // Keep the old method for backwards compatibility, but mark it as deprecated
    async addAllToCart() {
      console.warn("addAllToCart is deprecated, use createAndCheckout instead");
      return this.createAndCheckout();
    },

    clearAll() {
      pieces = [];
      PieceManager.updateDisplay();
      PieceManager.clearForm();
      elements.customerName.value = "";
    },

    showError(message) {
      elements.errorMessage.textContent = message;
      elements.errorMessage.style.display = "block";
      elements.successMessage.style.display = "none";
      setTimeout(() => {
        elements.errorMessage.style.display = "none";
      }, 5000);
    },

    showSuccess(message) {
      elements.successMessage.textContent = message;
      elements.successMessage.style.display = "block";
      elements.errorMessage.style.display = "none";
      setTimeout(() => {
        elements.successMessage.style.display = "none";
      }, 5000);
    },
  };

  // Initialize the calculator
  if (elements.form) {
    elements.form.addEventListener("submit", function (e) {
      e.preventDefault();

      const customerName = elements.customerName.value.trim();
      const globalShelfNumber = elements.globalShelfNumber.value.trim();
      const pieceName = elements.pieceName.value.trim();
      const weight = parseFloat(elements.pieceWeight.value);
      const firingType = document.querySelector(
        'input[name="firing-type"]:checked'
      );
      const customerType = document.querySelector(
        'input[name="customer-type"]:checked'
      );

      if (
        !customerName ||
        !globalShelfNumber ||
        !pieceName ||
        !weight ||
        !firingType ||
        !customerType
      ) {
        CartManager.showError("Please fill in all required fields");
        return;
      }

      // Updated weight validation - removed 1kg minimum, now allows 0.1g minimum
      if (weight <= 0 || weight > 50000) {
        const unit = elements.weightUnit.value;
        const maxWeight = unit === "kg" ? "50kg" : "50,000g";
        const minWeight = unit === "kg" ? "0.001kg" : "1g";
        CartManager.showError(
          `Weight must be between ${minWeight} and ${maxWeight}`
        );
        return;
      }

      const unit = elements.weightUnit.value;
      const cost = PricingCalculator.calculateCost(
        weight,
        unit,
        customerType.value
      );

      const pieceData = {
        name: pieceName,
        shelfNumber: globalShelfNumber,
        weight: weight,
        unit: unit,
        firingType: firingType.value,
        customerType: customerType.value,
        cost: cost,
        dateCreated: new Date().toLocaleDateString("en-IE"),
      };

      PieceManager.addPiece(pieceData);
    });

    // Real-time calculation listeners
    [elements.pieceWeight, elements.weightUnit].forEach((element) => {
      if (element) {
        element.addEventListener("input", () =>
          PieceManager.calculateRealTime()
        );
      }
    });

    // Customer type change listener
    document
      .querySelectorAll('input[name="customer-type"]')
      .forEach((radio) => {
        radio.addEventListener("change", () =>
          PieceManager.calculateRealTime()
        );
      });

    // Firing type change listener
    document.querySelectorAll('input[name="firing-type"]').forEach((radio) => {
      radio.addEventListener("change", () => PieceManager.calculateRealTime());
    });

    // Updated add to cart button listener to use new method
    if (elements.addToCartBtn) {
      elements.addToCartBtn.addEventListener("click", () =>
        CartManager.createAndCheckout()
      );
    }

    // Radio button visual feedback
    document.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener("change", function () {
        // Remove selected class from all radio options in the same group
        const groupName = this.name;
        document.querySelectorAll(`input[name="${groupName}"]`).forEach((r) => {
          r.closest(".radio-option").classList.remove("selected");
        });
        // Add selected class to the checked option
        this.closest(".radio-option").classList.add("selected");
      });
    });

    // Initialize radio button states on page load
    document
      .querySelectorAll('input[type="radio"]:checked')
      .forEach((radio) => {
        radio.closest(".radio-option").classList.add("selected");
      });
  }

  // Auto-logout functionality (if enabled)
  if (config.autoLogout && elements.countdownTimer) {
    let countdown = config.logoutTimeout / 1000; // Convert to seconds

    const updateTimer = () => {
      const minutes = Math.floor(countdown / 60);
      const seconds = countdown % 60;
      elements.countdownTimer.textContent = `${minutes}:${seconds
        .toString()
        .padStart(2, "0")}`;

      if (countdown <= 0) {
        // Auto logout - redirect to login or home page
        window.location.href = "/account/login";
        return;
      }

      countdown--;
    };

    // Update timer every second
    const timerInterval = setInterval(updateTimer, 1000);

    // Reset timer on user activity
    const resetTimer = () => {
      countdown = config.logoutTimeout / 1000;
    };

    // Listen for user activity
    ["click", "keypress", "scroll", "touchstart"].forEach((eventType) => {
      document.addEventListener(eventType, resetTimer, true);
    });
  }
});
